<template>
  <div v-if="!!$store.getters.getUserTasks.length" class="task-list-cnt">
    <h6 class="title">
      <span class="primary">{{ $t("Guadagna coins") }}</span>
      {{ $t("Completa le missioni per incrementare coins e punti exp") }}
    </h6>
    <ul class="task-list">
      <li
        class="col-4 task__item"
        v-for="(task, index) in $store.getters.getUserTasks"
        :key="index"
      >
        <router-link
          :event="task.type === 'identity.touchpoint' ? '' : 'click'"
          :to="getLink(task)"
          @click.native="getActionToDo($event, task)"
          class="item"
        >
          <div class="item__exp">
            <div
              class="item__exp-icon primary-bg"
              :class="[task.type.split('.').join('-')]"
              v-html="getIcon(task)"
            ></div>
            <div class="item__exp-points" v-if="task.data.points > 0">
              +{{ task.data.points }}
            </div>
          </div>
          <h6 class="item__task-type">{{ getCategory(task) }}</h6>
          <h5 class="item__task-desc">{{ getTitle(task) }}</h5>
          <p class="item__info-expire" v-if="task.data.claim">
            {{ task.data.claim || "Claim" }}
          </p>
          <button
            class="item__btn btn"
            type="button"
            v-if="task.type === 'insert.code'"
          >
            {{ $t("Inserisci") }}
          </button>
          <button
            class="item__btn btn"
            type="button"
            v-else-if="
              task.data.points > 0 ||
                (task.type === 'answer.instantwin' && task.data.max_points > 0)
            "
          >
            +
            {{
              task.type === "answer.instantwin"
                ? task.data.max_points
                : task.data.points
            }}
            {{ $t("coins") }}
          </button>
          <button class="item__btn btn" type="button" v-else>
            {{ $t("Go") }}
          </button>
        </router-link>
      </li>
    </ul>
    <information-modal
      @closeInformationModal="closeInformationModal"
      @readInformation="readInformation"
      v-if="showInformationModal"
      :content="currentInformationContent"
      :title="currentInformationTitle"
      :cta="currentInformationCta"
    ></information-modal>
  </div>
</template>

<script>
import iconSurvey from "@/assets/svg/new/SURVEY.svg";
import parseDomain from "parse-domain";
import Cookies from "js-cookie";

import iconFacebook from "@/assets/svg/new/identity.touchpoint.facebook.svg";
import iconGoogle from "@/assets/svg/new/identity.touchpoint.google.svg";
import iconApple from "@/assets/svg/new/identity.touchpoint.apple.svg";
import iconInstagram from "@/assets/svg/new/identity.touchpoint.instagram.svg";
import iconLinkedin from "@/assets/svg/new/identity.touchpoint.linkedin.svg";
import iconTwitter from "@/assets/svg/new/identity.touchpoint.twitter.svg";
import iconGarmin from "@/assets/svg/garmin_connect_logo.svg";

import iconAgreement from "@/assets/svg/new/agreement.request.svg";
import iconInstawin from "@/assets/svg/new/answer.instantwin.svg";
import iconQuestion from "@/assets/svg/new/answer.question.svg";
import iconDownload from "@/assets/svg/new/customevent.download.svg";
import iconExternal from "@/assets/svg/new/customevent.external.svg";
import iconGeneral from "@/assets/svg/new/general.svg";
import iconInformation from "@/assets/svg/new/information.read.svg";
import iconInstaFollow from "@/assets/svg/new/instagram.follow.svg";
import iconInstaHash from "@/assets/svg/new/instagram.hashtag.svg";
import iconInvite from "@/assets/svg/new/invite.friend.svg";
import iconVerifyMobile from "@/assets/svg/new/mobile.verified.svg";
import iconTwitterFollow from "@/assets/svg/new/twitter.follow.svg";
import iconTwitterHash from "@/assets/svg/new/twitter.hashtag.svg";
import iconCode from "@/assets/svg/new/insert.code.svg";
import iconInstantwinRandom from "@/assets/svg/new/dice.svg";
import iconVideo from "@/assets/svg/new/video.svg";
import iconPrediction from "@/assets/svg/new/magic.svg";

import informationModal from "@/components/Information.vue";

export default {
  name: "TaskList",
  data() {
    return {
      showInformationModal: false,
      currentInformationId: null,
      currentInformationContent: null,
      currentInformationCta: null
    };
  },
  methods: {
    getIcon(task) {
      const identity = "identity.touchpoint";
      if (task.type === identity) {
        const socialIcons = {
          facebook: iconFacebook,
          twitter: iconTwitter,
          google: iconGoogle,
          apple: iconApple,
          linkedin: iconLinkedin,
          instagram: iconInstagram,
          "garmin-connect": iconGarmin
        };

        const { provider } = task.data;

        return socialIcons[provider];
      }

      const icons = {
        "answer.survey": iconSurvey,
        "answer.question": iconQuestion,
        "invite.friend": iconInvite,
        "agreement.request": iconAgreement,
        "twitter.follow": iconTwitterFollow,
        "twitter.hashtag": iconTwitterHash,
        "instagram.follow": iconInstaFollow,
        "instagram.hashtag": iconInstaHash,
        "answer.instantwin": iconInstawin,
        "information.read": iconInformation,
        "customevent.download": iconDownload,
        "customevent.external": iconExternal,
        "mobile.verified": iconVerifyMobile,
        "insert.code": iconCode,
        "customevent.video": iconVideo,
        "instantwin.random": iconInstantwinRandom,
        prediction: iconPrediction
      };

      return icons[task.type] || iconGeneral;
    },
    getCategory(task) {
      const categories = {
        "mobile.verified": this.$i18n.t("Verifica"),
        "invite.friend": this.$i18n.t("Invita"),
        "identity.touchpoint": task.data.provider,
        "answer.survey": this.$i18n.t("Survey"),
        "answer.question": this.$i18n.t("Domanda"),
        "answer.instantwin": this.$i18n.t("Quiz"),
        "information.read": this.$i18n.t("Informazione"),
        "customevent.external": this.$i18n.t("Esterna"),
        "customevent.download": this.$i18n.t("Download"),
        "customevent.video": this.$i18n.t("Video"),
        "agreement.request": this.$i18n.t("Consensi"),
        "insert.code": this.$i18n.t("Codice"),
        "instantwin.random": this.$i18n.t("Instant Win"),
        "twitter.follow": this.$i18n.t("Follow"),
        "twitter.hashtag": this.$i18n.t("Hashtag"),
        "twitter.retweet": this.$i18n.t("Retweet"),
        "instagram.follow": this.$i18n.t("Follow"),
        "instagram.hashtag": this.$i18n.t("Hashtag"),
        "instagram.tag": this.$i18n.t("Tag"),
        prediction: this.$i18n.t("Pronostico"),
        upload: this.$i18n.t("Upload")
      };

      return categories[task.type] || "Not defined type";
    },
    getTitle(task) {
      const titles = {
        "identity.touchpoint": this.$i18n.t(
          "Connetti il tuo {provider} account",
          {
            provider: task.data.provider
          }
        ),
        "mobile.verified": this.$i18n.t("Verifica il tuo telefono"),
        "invite.friend": this.$i18n.t("Invita un amico"),
        "answer.survey": task.data.title,
        "answer.question": task.data.title,
        "answer.instantwin": task.data.title,
        "information.read": task.data.title,
        "customevent.external": task.data.text,
        "customevent.download": task.data.text,
        "customevent.video": task.data.title,
        "insert.code": this.$i18n.t("Inserisci Codice"),
        "instantwin.random": task.data.title,
        "twitter.follow": "@" + task.data.label,
        "twitter.hashtag": "#" + task.data.label,
        "twitter.retweet": "@" + task.data.label,
        prediction: task.data.title,
        upload: task.data.title
      };

      return (
        titles[task.type] ||
        task.data.title ||
        task.data.label ||
        task.data.text ||
        "No title defined"
      );
    },
    getLink(task) {
      const routes = {
        "identity.touchpoint": `registerSocial/`,
        "mobile.verified": "verify/mobile",
        "invite.friend": "invite",
        "answer.survey": `survey/${task.data.id}`,
        "answer.question": `survey/${task.data.id}`,
        prediction: `prediction/${task.data.id}`,
        "answer.instantwin": `instantwin/${task.data.id}`,
        "customevent.video": `video/${task.data.id}`,
        "insert.code": "/code",
        "instantwin.random": `instantwinRandom/${task.data.id}`,
        "agreement.request": `settings/profile?tab=2`,
        upload: `upload/${task.data.id}`
      };
      return routes[task.type] || "";
    },
    getActionToDo(event, task) {
      const taskTypesTwitter = [
        "twitter.follow",
        "twitter.retweet",
        "twitter.hashtag"
      ];
      const taskTypesTwitterURL = {
        "twitter.follow": "https://twitter.com/intent/follow?screen_name=",
        "twitter.retweet": "https://twitter.com/",
        "twitter.hashtag": "https://twitter.com/intent/tweet?hashtags="
      };

      if (taskTypesTwitter.includes(task.type)) {
        return window.open(
          taskTypesTwitterURL[task.type] + task.data.label,
          "_blank"
        );
      }

      if (task.type === "identity.touchpoint") {
        this.getSocialLoginLink(event, task.data);
      }

      if (task.type === "customevent.external") {
        window.location =
          task.data.link +
          "?event_id=" +
          task.data.id +
          "&user_id=" +
          this.$store.state.user.id +
          "&back_to=" +
          this.currentTenant;
      }
      if (task.type === "customevent.download") {
        this.downloadFile(task);
      }
      if (task.type === "information.read") {
        this.getInformation(task.data);
      }

      return;
    },
    getSocialLoginLink(event, provider) {
      event.stopPropagation();
      this.$http
        .get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/" +
            provider.provider +
            "/socialLoginUrl"
        )
        .then(response => {
          const parsedDomain = parseDomain(window.location.hostname);
          if (response.data.data.url) {
            Cookies.set("fanize_social_fallback", window.location.hostname, {
              domain: "." + parsedDomain.domain + "." + parsedDomain.tld
            });
            Cookies.set(
              "fanize_social_token",
              this.$store.state.authorization.access_token,
              { domain: "." + parsedDomain.domain + "." + parsedDomain.tld }
            );
            window.location = response.data.data.url;
          }
        });
    },
    downloadFile(task) {
      this.$http({
        url:
          "/api/v1/campaigns/" +
          this.$store.state.campaign.id +
          "/events/" +
          task.data.id +
          "/download",
        method: "GET"
      }).then(response => {
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = task.data.link;
        a.target = "_blank";
        a.click();
        this.$store.dispatch("getUserTasks");
        this.$store.dispatch("getUnreadMessages");
      });
    },
    // START INFORMATION MDAOL LOGIC
    async getInformation(task) {
      this.$store.commit("showSpinner");
      this.currentInformationId = task.id;
      this.currentInformationTitle = task.title;
      try {
        let response = await this.$http.get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/information/" +
            task.id
        );
        this.currentInformationContent = _.get(
          response,
          "data.data.content",
          ""
        );
        this.currentInformationCta = _.get(response, "data.data.cta", "");
        this.showInformationModal = true;
      } catch {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    },
    closeInformationModal() {
      this.$store.dispatch("getUserInfo");
      this.$store.dispatch("getUserTasks");
      this.$store.dispatch("getUnreadMessages");
      this.currentInformationId = null;
      this.currentInformationTitle = null;
      this.currentInformationContent = null;
      this.currentInformationCta = null;
      this.showInformationModal = false;
    },
    async readInformation() {
      this.$store.commit("showSpinner");
      try {
        await this.$http.post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/information/" +
            this.currentInformationId
        );
        await this.$store.dispatch("getUnreadMessages");
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "waiting",
          title: "Something went wrong",
          text: "Please retry"
        });
      }

      this.$store.commit("hideSpinner");
    }
    // END INFORMATION MDAOL LOGIC
  },
  computed: {
    currentTenant() {
      return window.location.protocol + "//" + window.location.host;
    }
  },
  components: {
    informationModal
  }
};
</script>

<style lang="scss" scoped>
.task-list-cnt {
  margin-bottom: 20px;
  @media (min-width: 767px) {
    margin-bottom: 0;
  }
}
.title {
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
}

.task-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  @media (min-width: 767px) {
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 -15px;
    gap: 0;
  }
}
.col-4 {
  @media (max-width: 767px) {
    flex: unset;
  }
}

.task__item {
  display: flex;
  flex: 1 1 100%;
  margin-bottom: 0;

  @media (min-width: 767px) {
    flex: 0 0 33.3333%;
    margin-bottom: 35px;
    min-width: 200px;
    padding: 0 5px;
    &:first-of-type,
    &:nth-of-type(3n + 1) {
      padding-left: 15px;
    }

    &:nth-of-type(3n - 1) {
      padding: 0 10px;
    }

    &:nth-of-type(3n) {
      padding-right: 15px;
    }
  }
}
.title {
  color: #5e6264;
  font-size: 14px;
  span {
    font-size: 22px;
    font-weight: 900;
  }
}

.item {
  border-radius: 5px;
  background-color: #fff;
  padding: 25px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  box-shadow: 1px 22px 15px 2px rgba(0, 0, 0, 0.1);
  width: 100%;
  &:hover {
    text-decoration: none;
  }
}
.item__exp {
  position: relative;
  margin: 10px 0;
}

.item__exp-points {
  position: absolute;
  border-radius: 50%;
  background-color: #50d34d;
  color: #fff;
  height: 28px;
  width: 28px;
  font-size: 12px;
  line-height: 28px;
  text-align: center;
  bottom: 4px;
  right: -9px;
}

.item__task-type {
  font-style: italic;
  font-size: 14px;
  text-align: center;
}

.item__task-desc {
  text-align: center;
  font-size: inherit;
  margin-bottom: 20px;
  font-weight: bold;
}

.item__btn {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  font-weight: bold;
  text-align: center;
  background: #ffce00;
}

.item__info-expire {
  color: #ff0000;
  font-size: 13px;
  margin-top: auto;
}

.item__exp-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  padding: 10px;

  ::v-deep svg {
    object-fit: contain;
    width: 100%;
    height: 100%;

    path {
      fill: #fff;
    }
  }
}
.answer-survey {
  display: flex;
  justify-content: center;
  align-items: center;
  ::v-deep svg {
    height: 25px;
    width: 25px;
  }
}
</style>
